'use client';

import {styled} from "@mui/system";
import {Box} from "@mui/material";

const IssueItemBox = styled(Box)(() => ({
    marginY: '.5rem',
    textAlign: 'left'
}));

export default IssueItemBox;
